import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67f7d396"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "far fa-calendar-times me-2" }, null, -1))
const _hoisted_2 = { class: "px-3" }
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = {
  key: 0,
  class: "invalid-feedback d-inline",
  role: "alert"
}
const _hoisted_5 = { class: "mb-3" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "description",
  class: "form-label text-muted"
}, " หมายเหตุ: ", -1))
const _hoisted_7 = {
  key: 0,
  class: "invalid-feedback d-inline",
  role: "alert"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-trash-alt" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-ban" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-save" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_BaseModalComponent = _resolveComponent("BaseModalComponent")!

  return (_openBlock(), _createBlock(_component_BaseModalComponent, {
    ref: "enddateForm",
    backdrop: "static",
    onHide: _ctx.clearForm,
    onHidden: _ctx.handleHidden
  }, {
    title: _withCtx(() => [
      _hoisted_1,
      _createTextVNode(_toDisplayString(_ctx.title), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("label", {
            for: "endDate",
            class: _normalizeClass(["form-label text-muted", {'is-invalid': _ctx.submited && _ctx.errors.endDate}])
          }, " วันที่สิ้นสุดโครงการ: ", 2),
          (_ctx.submited && _ctx.errors.endDate)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, " * กรุณาเลือกวันที่สิ้นสุดโครงการ "))
            : _createCommentVNode("", true),
          _createVNode(_component_Datepicker, {
            modelValue: _ctx.formData.endDate,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.endDate) = $event)),
            enableTimePicker: false,
            locale: "th-TH",
            format: "dd/MM/yyyy",
            weekStart: "0",
            position: "left",
            autoApply: "",
            placeholder: "กรุณาเลือกวันที่สิ้นสุดโครงการ...",
            class: _normalizeClass(["form-control p-0", {'is-invalid': _ctx.submited && _ctx.errors.endDate}]),
            onChange: _ctx.unsubmit
          }, null, 8, ["modelValue", "class", "onChange"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          (_ctx.submited && _ctx.errors.remark)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, " * กรุณาป้อนหมายเหตุ "))
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("textarea", {
            class: _normalizeClass(["form-control", {'is-invalid': _ctx.submited && _ctx.errors.remark}]),
            placeholder: "กรุณาป้อนหมายเหตุ...",
            "aria-label": "remark",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.remark) = $event)),
            onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.unsubmit && _ctx.unsubmit(...args)))
          }, "\n          ", 34), [
            [_vModelText, _ctx.formData.remark]
          ])
        ])
      ])
    ]),
    footer: _withCtx(() => [
      (_ctx.isEditMode && _ctx.canDelete)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "btn btn-danger me-auto",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.deleteClick && _ctx.deleteClick(...args)))
          }, [
            _hoisted_8,
            _createTextVNode(" ลบ ")
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-secondary",
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args)))
      }, [
        _hoisted_9,
        _createTextVNode(" ปิด ")
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary",
        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.submitClick && _ctx.submitClick(...args)))
      }, [
        _hoisted_10,
        _createTextVNode(" บันทึก ")
      ])
    ]),
    _: 1
  }, 8, ["onHide", "onHidden"]))
}